import React, {Component} from 'react';
import './style.css';

export default class NicePanel extends Component {
	render() {
		return (
			<div className="com-nicepanel">
				<div className="p-header">
					{this.props.title}
				</div>
				<div className="p-body">
					{this.props.children}
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/04-containers/NicePanel/index.js